import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import CheckedBell from 'assets/svgs/checkedBell.svg';
import { Tooltip, Typography } from '@mui/material';
import * as notificationActions from 'features/notifications/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import * as dashboardActions from 'features/dashboard/duck';
import { NotificationDetails } from 'features/notifications';
import { mapFilteredNotificationsDays } from 'features/notifications/selectors';
import NotificationBellIcon from 'assets/svgs/notificationBellIcon.svg';
import NotificationBellIconWithBadge from 'assets/svgs/notificationBellIconWithBadge.svg';

import './NotificationsPreview.scss';

class NotificationsPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
      currentNotification: {},
    };

    this.hideTooltip = this.hideTooltip.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.updateNotifications = this.updateNotifications.bind(this);
    this.openNotification = this.openNotification.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;

    this.props.actions.getNotViewedNotificationsCount(user.id);
    if (!this.state.showTooltip) {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    document.getElementById('clickable').addEventListener('click', this.updateNotifications);
  }

  componentDidUpdate(prevProps) {
    const tooltip = !!sessionStorage.getItem('notificationTooltip');

    if (
      tooltip &&
      !prevProps.notificationsCount &&
      !prevProps.termsLoading &&
      !prevProps.terms.length &&
      (prevProps.notificationsCount !== this.props.notificationsCount ||
        prevProps.termsLoading !== this.props.termsLoading ||
        prevProps.terms !== this.props.terms)
    ) {
      this.setState({
        showTooltip: tooltip,
      });
      document.addEventListener('click', this.handleOutsideClick, false);
      sessionStorage.removeItem('notificationTooltip');
    }

    if (
      !this.props.loadingNotViewedCount &&
      !this.props.notificationsCount &&
      this.state.showTooltip &&
      (prevProps.loadingNotViewedCount !== this.props.loadingNotViewedCount ||
        prevProps.notificationsCount !== this.props.notificationsCount)
    ) {
      this.setState({
        showTooltip: false,
      });
      sessionStorage.removeItem('notificationTooltip');
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    if (tooltip && !prevProps.notificationsCount) {
      this.setState({
        showTooltip: tooltip,
      });
      document.addEventListener('click', this.handleOutsideClick, false);
      sessionStorage.removeItem('notificationTooltip');
    }
  }

  hideTooltip() {
    this.setState({
      showTooltip: false,
    });
    sessionStorage.removeItem('notificationTooltip');
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }

    this.hideTooltip();
  }

  updateNotifications() {
    const { user } = this.props;
    if (this.state.showTooltip) {
      this.hideTooltip();
    }
    this.props.actions.getServerDateTime();
    this.props.actions.getNotViewedNotifications(user.id);
    this.props.actions.getNotViewedNotificationsCount(user.id);
  }

  openNotification(notification) {
    const { user } = this.props;

    this.setState({
      currentNotification: notification,
    });

    this.props.actions
      .setNotificationAsRead(user.id, { notificationId: notification.id })
      .then(() => {
        this.props.actions.getNotViewedNotifications(user.id);
        this.props.actions.getNotViewedNotificationsCount(user.id);
      });
  }

  closeNotification() {
    this.setState({
      currentNotification: null,
    });
    this.props.actions.clearNotificationsAction();
    this.props.actions.getAllNotifications(this.props.user.id, { limit: 12 });
  }

  render() {
    const { notificationsCount, notViewedNotifications, loadingNotViewed, loadingNotViewedCount } =
      this.props;
    const { currentNotification, showTooltip } = this.state;
    const emptyList = !notViewedNotifications.length;

    return (
      <div className="notification-container bell-container">
        <div className="dropdown">
          <div
            className="bell-icon"
            id="clickable"
            role="button"
            data-bs-toggle="dropdown"
            data-bs-target="drop"
            aria-expanded="false"
            data-bs-display="static"
            ref={(node) => {
              this.node = node;
            }}>
            {!notificationsCount || (!notificationsCount && loadingNotViewedCount) ? (
              <NotificationBellIcon />
            ) : (
              <div>
                <Tooltip
                  arrow
                  open={showTooltip}
                  placement="bottom-end"
                  title={
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: this.props.t('notifications.warningMessage', {
                          total: notificationsCount,
                        }),
                      }}
                      variant="body2"
                    />
                  }>
                  <NotificationBellIconWithBadge id="notificationIconId" />
                  {notificationsCount && (
                    <span className={`${notificationsCount > 9 ? 'wide-badge' : ''} badge`}>
                      {notificationsCount > 99 ? '99+' : notificationsCount}
                    </span>
                  )}
                </Tooltip>
              </div>
            )}
          </div>

          <div
            className="dropdown-menu notification-dropdown-menu "
            aria-labelledby="notifications-dropdown"
            id="drop">
            <span className="dropdown-menu-arrow" />

            <div className="dropdown-header pt-0 border-bottom-gray text-end">
              {/*<span className="notification-title">*/}
              {/*{this.props.t('notifications.label')}{!emptyList && !loadingNotViewed && `(${notViewedNotifications.length})`}*/}
              {/*</span>*/}
              <span className="font-size-10">
                {this.props.t('notifications.clickNotificationMessage')}
                <i className="fa fa-info-circle ps-1" />
              </span>
            </div>
            {loadingNotViewed ? (
              <div
                id="notificationsLoader"
                className="dropdown-item dropdown-notification "
                href="#">
                <p className="notification-solo text-center w-100 ">
                  <i
                    id="notificationsIcon"
                    className="fa fa-spinner fa-pulse fa-fw"
                    aria-hidden="true"
                  />{' '}
                </p>
              </div>
            ) : emptyList ? (
              <div className="dropdown-item dropdown-notification-empty">
                <CheckedBell />{' '}
                <span className="empty-dropdown">
                  {this.props.t('notifications.noUnreadNotifications')}
                </span>
              </div>
            ) : (
              <div className="dropdown-notifications-container">
                {notViewedNotifications.map((notif) => (
                  <div
                    key={notif.id}
                    className="dropdown-item dropdown-notification"
                    onClick={() => this.openNotification(notif)}>
                    <div className="circle">
                      <i className="fa fa-circle" aria-hidden="true" />
                    </div>
                    <div className="info">
                      <p className="info-title fw-bold">{notif.title}</p>
                      <div>
                        {notif.days
                          ? this.props.t('notifications.daysLabel', {
                              count: notif.days,
                            })
                          : this.props.t('common.labels.today')}
                        <span className="fw-bold"> - {this.props.t('common.labels.unread')}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="notifications-footer">
              <a className="dropdown-notification-all" href="/notifications">
                {this.props.t('common.labels.seeAll')}
              </a>
            </div>
          </div>
        </div>
        <NotificationDetails
          modalIsOpen={!isEmpty(currentNotification)}
          notification={currentNotification}
          closeNotification={this.closeNotification}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.currentUser || {},
    notViewedNotifications: mapFilteredNotificationsDays(state),
    notificationsCount: state.notifications.notViewedNotificationsCount,
    loadingNotViewed: state.notifications.loadingNotViewed,
    loadingNotViewedCount: state.notifications.loadingNotViewedCount,
    terms: state.userDashboard.terms,
    termsLoading: state.userDashboard.termsLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...notificationActions,
        ...dashboardActions,
        ...staticActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(NotificationsPreview)
);

NotificationsPreview.propTypes = {
  notificationsCount: PropTypes.number,
  notViewedNotifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      days: PropTypes.number,
    })
  ).isRequired,
  loadingNotViewed: PropTypes.bool.isRequired,
  loadingNotViewedCount: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    getNotViewedNotifications: PropTypes.func.isRequired,
    getNotViewedNotificationsCount: PropTypes.func.isRequired,
    getAllNotifications: PropTypes.func.isRequired,
    getServerDateTime: PropTypes.func.isRequired,
    setNotificationAsRead: PropTypes.func.isRequired,
    clearNotificationsAction: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  terms: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  termsLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};
